import React from 'react';
import Button from '../ui/Button';

export default function GroupsEmptyState({
  hasInvites,
  userCanCreate,
  onCreateLeague,
  onSeePlus,
}) {
  if (hasInvites) {
    return (
      <div className="space-y-2">
        <p className="text-sm text-gray-400 font-medium leading-relaxed">
          Accept a league invite above to join your crew, see the activity feed, and climb the leaderboard.
        </p>
      </div>
    );
  }

  if (userCanCreate) {
    return (
      <div className="space-y-3">
        <p className="text-sm text-gray-400 font-medium leading-relaxed">
          Create your first league, invite friends by arena name, and post group locks with your roster.
        </p>
        <Button type="button" variant="admin" size="sm" onClick={onCreateLeague}>
          Create your first league
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-400 font-medium leading-relaxed">
        Waiting for an invite? Ask a Plus member to add you to their league. You can join up to two leagues on a free account.
      </p>
      <p className="text-sm text-gray-500 font-medium leading-relaxed">
        Want your own league? Plus unlocks creating leagues, group locks, and unlimited memberships.
      </p>
      {onSeePlus && (
        <Button type="button" variant="ghost" size="sm" onClick={onSeePlus}>
          See what Plus unlocks
        </Button>
      )}
    </div>
  );
}
